
import { FormGroup, FormControl, FormArray, Validators } from '@angular/forms';


export function getVerifyReservationManuallyDtoFormGroup() {
return new FormGroup({
    sendConfirmationEmail: new FormControl<boolean | undefined>(undefined),
    ignoreCalendarConflict: new FormControl<boolean | undefined>(undefined),
})
;
}
      